// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require core_post_webpack/widgets/_namespace
//= require core_post_webpack/widgets/deprecated_base
//= require bootstrap/tooltip
//= require core_post_webpack/widgets/bootstrap_tooltip_overrides
//= require bootstrap/popover
//= require core_post_webpack/widgets/hover_popover
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/core_post_webpack/widgets/_namespace.coffee')
require('javascripts/core_post_webpack/widgets/deprecated_base.js')
require('bootstrap/js/tooltip.js')
require('sprocket-compat?this!javascripts/core_post_webpack/widgets/bootstrap_tooltip_overrides.coffee')
require('bootstrap/js/popover.js')
require('sprocket-compat?this!javascripts/core_post_webpack/widgets/hover_popover.coffee')
// MAGIC_DESPROCKET_END
